/** Width presets (%) shown as quick picks in the image embed dialog. */
export const IMAGE_EMBED_QUICK_PERCENTS = [25, 50, 75, 100];

export const DEFAULT_IMAGE_EMBED_PERCENT = 50;
export const IMAGE_EMBED_MIN_PERCENT = 10;
export const IMAGE_EMBED_MAX_PERCENT = 100;

const LEGACY_SIZE_MAP = {
    small: 25,
    medium: 50,
    large: 75,
    full: 100,
};

export function normalizeImageWidthPercent(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return DEFAULT_IMAGE_EMBED_PERCENT;
    return Math.min(IMAGE_EMBED_MAX_PERCENT, Math.max(IMAGE_EMBED_MIN_PERCENT, Math.round(n)));
}

/** Parse `image`, `image:50`, or legacy `image:medium` from markdown alt text. */
export function parseImageAltWidth(alt) {
    const raw = (alt || '').trim();
    const match = raw.match(/^image(?::(.+))?$/i);
    if (!match) return DEFAULT_IMAGE_EMBED_PERCENT;

    const token = (match[1] || String(DEFAULT_IMAGE_EMBED_PERCENT)).toLowerCase();
    if (LEGACY_SIZE_MAP[token] !== undefined) return LEGACY_SIZE_MAP[token];

    const num = parseInt(token, 10);
    if (Number.isFinite(num)) return normalizeImageWidthPercent(num);

    return DEFAULT_IMAGE_EMBED_PERCENT;
}

export function getImageEmbedStyle(widthPercent = DEFAULT_IMAGE_EMBED_PERCENT, options = {}) {
    const pct = normalizeImageWidthPercent(widthPercent);
    const display = options.inline ? 'inline-block' : 'block';
    const verticalAlign = options.inline ? 'middle' : 'initial';
    return `width:${pct}%;max-width:100%;height:auto;border-radius:12px;margin:${options.inline ? '0.25rem' : '1rem'} auto;display:${display};vertical-align:${verticalAlign};box-shadow:0 4px 12px rgba(0,0,0,0.08);`;
}

export function buildImageMarkdown(url, widthPercent = DEFAULT_IMAGE_EMBED_PERCENT) {
    const pct = normalizeImageWidthPercent(widthPercent);
    return `![image:${pct}](${url})`;
}

export function buildImageHtml(url, widthPercent = DEFAULT_IMAGE_EMBED_PERCENT, options = {}) {
    const pct = normalizeImageWidthPercent(widthPercent);
    const style = getImageEmbedStyle(pct, options);
    return `<img src="${url}" class="embedded-image" alt="image:${pct}" loading="lazy" decoding="async" style="${style}" />`;
}
